import calcCurrentAbility from '../helpers/calcCurrentAbility'
//----------------------
// calc general details
//----------------------
export default function calcGeneralDetails({ character }) {
  //-----------------
  // calc move (cur)
  //-----------------
  character.move_cur = calcCurrentAbility({
    base: character.move_base,
    adjs_tot: character.move_adjs_tot,
  })
  //--------------------
  // calc move fly (cur)
  //---------------------
  if (character.move_fly_base > 0) {
    character.move_fly_cur = calcCurrentAbility({
      base: character.move_fly_base,
      adjs_tot: character.move_fly_adjs_tot,
    })
  }

  return character
}
